import { render, staticRenderFns } from "./InviteTab.vue?vue&type=template&id=7b6ca1c9&scoped=true"
import script from "./InviteTab.vue?vue&type=script&lang=js"
export * from "./InviteTab.vue?vue&type=script&lang=js"
import style0 from "./InviteTab.vue?vue&type=style&index=0&id=7b6ca1c9&prod&lang=scss&scoped=true"
import style1 from "./InviteTab.vue?vue&type=style&index=1&id=7b6ca1c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ca1c9",
  null
  
)

export default component.exports